module.exports = __webpack_public_path__ + "img/android4icon1.3d938d86.png";